<template>
  <div class="text-center">
    <img alt="Vue logo" src="../assets/vue_logo.png">    
    <h1>{{ msg }}</h1>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
    <br/>
    <img alt="Bootstrap logo" src="../assets/bootstrap_logo.png">
    <h1>... And Bootstrap</h1>
    <ul>
      <li><a href="https://getbootstrap.com/" target="_blank" rel="noopener">bootstrap</a></li>
      <li><a href="https://bootstrap-vue.js.org" target="_blank" rel="noopener">bootstrap-vue</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
